module.exports = __webpack_public_path__ + "static/stabilization-light-247617e85a89c26baa44f915bcdc1ca3.svg";